function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg141Singapore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#F0F0F0"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 256
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M69.565,128c0-35.744,25.121-65.604,58.666-72.93c-5.157-1.126-10.505-1.736-16-1.736   c-41.238,0-74.666,33.428-74.666,74.666s33.428,74.666,74.666,74.666c5.495,0,10.843-0.61,16-1.736   C94.687,193.604,69.565,163.744,69.565,128z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "165.565,58.666 170.861,74.965 187.996,74.965 174.133,85.037 179.429,101.334    165.565,91.262 151.701,101.334 156.997,85.037 143.134,74.965 160.269,74.965  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "123.996,90.666 129.292,106.965 146.428,106.965 132.565,117.037 137.86,133.334    123.996,123.262 110.133,133.334 115.429,117.037 101.565,106.965 118.701,106.965  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "207.134,90.666 212.43,106.965 229.565,106.965 215.701,117.037 220.997,133.334    207.134,123.262 193.27,133.334 198.566,117.037 184.703,106.965 201.838,106.965  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "191.134,138.666 196.43,154.965 213.565,154.965 199.701,165.037 204.997,181.334    191.134,171.262 177.27,181.334 182.566,165.037 168.703,154.965 185.838,154.965  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "139.996,138.666 145.292,154.965 162.428,154.965 148.565,165.037 153.86,181.334    139.996,171.262 126.133,181.334 131.429,165.037 117.565,154.965 134.701,154.965  "
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg141Singapore);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };